module.exports = "<div id=\"y-radio\" class=\"y-radio\"\n  data-bind=\"foreach: {data: dataList, as: 'item'}, css:{'y-radio-hor':direction == 'horizontal','y-radio-ver':direction == 'vertical'}\">\n  <y-radio-item params=\"fieldid: $parent.fieldid ,radioname: $parent.radioname, value: item, currentValue: $parent.value, onChange: $parent.onChange\"></y-radio-item>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/radio/index.html
// module id = 205
// module chunks = 0